<ng-container *transloco="let transloco">
  <div class="relative w-full h-full flex flex-col bg-white">
    <p class="w-full flex justify-center items-center text-center text-[16px] font-[500] break-keep">{{ "Forgot your password? Enter your email and we'll send you a link to reset it." | transloco }}</p>
    <form [formGroup]="forgotPasswordGroup" class="relative w-full h-full flex flex-col overflow-y-scroll">
      <div class="mt-12 w-full flex flex-col gap-[10px]">
        <input class="w-full px-2 py-4 border-2 border-black/20 outline-2 outline-black rounded" type="email" placeholder="example@example.com" autocomplete="email" autofocus formControlName="email" />
      </div>
    </form>
    <div class="flex-none mt-12 relative w-full h-[55px] flex flex-row gap-[14px]">
      <button class="w-full h-full flex justify-center items-center rounded-lg bg-black text-[16.8px] font-[600] text-white disabled:bg-gray-300" (click)="onClickSubmit()" [disabled]="!forgotPasswordGroup.valid">{{ 'Send' | transloco }}</button>
      <button class="w-full h-full flex justify-center items-center rounded-lg bg-black text-[16.8px] font-[600] text-white" (click)="onClickCancel()">{{ 'Cancel' | transloco }}</button>
    </div>
  </div>
</ng-container>
